<div class="rename-dialog">

  <div class="ui-g-12 p-zero dialog-header">
    <i class="fal fa-edit font-20 font-gray-55"></i>
    <div class="send-dialog-heading font-bold font-16 font-secondary-900">Rename attachment</div>
    <i class="fal fa-times fa-sm dialog-close" (click)="closeDialog({})"></i>
  </div>

  <div class="ui-g-12 p-zero dialog-body">
    <div class="attachment-file-wrapper-vertical">
      <div class="attachment-file-wrapper">
        <div class="attachment-input">
          <app-input id="part-total-price" [value]="attachment[titleKey]" type="text" placeholder="Attachment title"
            label="Attachment title" (appChange)="handleChange($event,titleKey)" theme="light" maxlength="50"
            [fontSize]="14" [floatingLabel]="true"></app-input>
        </div>
        <div class="attachment-format">
          <span class="attachment-text">
            {{'.'+attachment.fileExtension}}
          </span>
        </div>
      </div>
    </div>
  </div>

  <div class="ui-g-12 p-zero dialog-footer">
    <div class="float-right text-right">
      <button class="btn btn-border btn-submit mr-2" (click)="closeDialog({})">Cancel</button>
      <button class="btn btn-primary btn-submi" style="min-width: 90px; height: 33px;" (click)="save()">Save</button>
    </div>
  </div>
</div>
